import type { ContainerType } from "~/container";
import type { IApi } from "~/interfaces/IApi";
import type { IAuthService } from "@saif-reporting/domain/interfaces/services/IAuthService.js";
import type { LoginRequest, LoginResponse, RefreshTokenRequest, LogoutRequest, WebLoginResponse } from "@saif-reporting/domain/dtos/authDtos.js";

export class AuthService implements IAuthService {
  private readonly api: IApi;
  constructor({ baseApi }: ContainerType) {
    this.api = baseApi;
  }

  async login(dto: LoginRequest): Promise<LoginResponse> {
    const res = await this.api.$fetch<LoginResponse>("/auth/login", {
      method: "post",
      body: dto,
    });
    return res;
  }

  async Weblogin(dto: LoginRequest): Promise<WebLoginResponse> {
    const res = await this.api.$fetch<LoginResponse>("/auth/web-login", {
      method: "post",
      body: dto,
    });
    return res;
  }

  async refreshToken(dto: RefreshTokenRequest): Promise<LoginResponse> {
    const res = await this.api.$fetch<LoginResponse>("/auth/refresh-token", {
      method: "post",
      body: dto,
    });

    return res;
  }

  async logout(dto: LogoutRequest): Promise<void> {
    await this.api.$fetch("/auth/logout", {
      method: "post",
      body: dto,
    });
  }

  async webLogout(): Promise<void> {
    await this.api.$fetch("/auth/web-logout", {
      method: "post",
    });
  }
}
